import { FC } from 'react';

import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  multipleVariations?: boolean;
}

/**
 * Settings Modal for VariationSix
 * Wraps the shared SettingsModal with variation-specific configuration
 *
 * Before refactoring: 144 lines
 * After refactoring: 52 lines (64% reduction)
 */
const SettingsModal: FC<Props> = ({ multipleVariations, image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      ...WATERMARK_SECTIONS,
      {
        title: 'Text Parameters',
        type: 'checkbox',
        stateKey: '',
        checkboxes: [
          { key: 'quotes', label: 'Quotes' },
          { key: 'brakes', label: 'Custom brakes' },
        ],
        show: multipleVariations,
      },
    ]}
  />
);

export default SettingsModal;
